module.exports = __webpack_public_path__ + "static/9-19eecb3e4346e7c47251a5abf54b6424.jpeg";